module.exports = __webpack_public_path__ + "static/media/gmail.d0915bc3.svg";